<template>
  <div class="product-search">
    <SearchRefiners
    :results="results"
    :selectedFacetOptions="selectedFacetOptions"
    @applyFilters="onApplyFilters"
    @resetFilters="onResetFilters"
    :labels="labels"
    >
      <template #custom-filters>
        <div class="country-products">
          <ul>
            <FacetOption 
              :label="labels.removeCountryFilter" 
              :on-change="onToggleRemoveCountryFilter" 
              :checked="removeCountryFilter"
              :tooltip="labels.countryFilterTooltip"
            />
          </ul>
        </div>
      </template>
    </SearchRefiners>
    <div>
      <div class="products" v-if="results.rows.length > 0">
        <div v-for="product in results.rows" class="product-entry" :key="product.id" itemscope
          itemtype="https://schema.org/Product">
          <a :href="product.url" class="product-image" :style="{ backgroundImage: 'url(' + product.imageUrl + ')' }"
            itemprop="url" :title="product.title">
          </a>
          <div class="product-details">
            <div>
                <div class="product-title" style="word-wrap: break-word;" itemprop="name" @click="onItemClicked(product)">
                  {{ product.title }}</div>
              <div class="product-subtitle" style="word-wrap: break-word;" itemprop="subjectOf"
                @click="onItemClicked(product)">{{ productSubtitle(product) }}</div>
              <div class="product-description" style="word-wrap: break-word;">
                <span v-html="product.description" itemprop="description" @click="onItemClicked(product)"></span>
                <div class="links">
                  <a class="animated blue-arrow more" :href="product.url" :title="product.title">{{ labels.more }}</a>
                  <a class="animated blue-arrow" 
                    v-if="shouldShowSDSLink(product)" 
                    :href="getDocFinderUrl(product)"
                    :title="labels.docFinder">{{ labels.docFinder }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Pager :total-items="results.totalRows" :current-items="results.rows.length" @click="onShowMore"></Pager>
      </div>
      <div class="no-items" v-if="results.rows.length == 0 && !isLoading">{{ labels.noItemsFound }}</div>
    </div>
    <div class="please-wait" v-if="isLoading">
      <img src="../assets/pic_loading.gif" />
    </div>
  </div>
</template>

<script>
import { Bus } from './services/bus.js'
import { Labels } from './services/labels.js'
import { Settings } from './services/settings.js'
import { Utils } from './services/utils.js'
import Facet from './ui/Facet.vue'
import FacetOption from './ui/FacetOption.vue'
import Pager from './ui/Pager.vue'
import axios from 'axios'
import { SessionState } from './services/session-state.js'
import Pill from './ui/Pill.vue'
import Modal from './ui/Modal.vue'
import FacetSelector from './ui/FacetSelector.vue'
import SearchRefiners from './ui/SearchRefiners.vue'

export default {
  name: 'ProductSearch',
  components: {
    Facet,
    FacetOption,
    Pager,
    Pill,
    Modal,
    FacetSelector,
    SearchRefiners
  },
  data() {
    return {
      labels: Labels,
      settings: Settings,
      isLoading: false,
      currentQuery: "",
      tags: "",
      results: {
        rows: [],
        facets: []
      },
      collapsedFacets: Settings.products.collapsedFacets,
      selectedFacetOptions: [],
      isFirstQuery: true,
      hiddenFacets: Settings.hiddenFacets,
      showGreenProducts: false,
      removeCountryFilter: false,
    }
  },
  created() {
    Bus.$on("start-search", this.search)
  },
  beforeDestroy() {
    Bus.$off('start-search');
  },
  mounted() {
    var facetOpts = SessionState.get("products", "facets");
    if (facetOpts) {
      this.selectedFacetOptions = JSON.parse(facetOpts);
    }
  },
  methods: {
    onItemClicked(item) {
      if (!item) return;
      window.open(item.url, "_self");
    },
    isCollapsed(facet) {
      if (this.collapsedFacets.indexOf(facet.name) != -1) return true;
      else return false;
    },
    getCurrentCountry() {
      return Utils.getCookie("CLACountry");
    },
    search(filters, fromWithin) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      oThis.tags = filters.tags;
      console.log("Searching for products with " + filters.query)
      if (filters.query && !Settings.allowBulkNumberSearch && !isNaN(filters.query.trim()) && filters.query.trim().length === 6) {
        //we don't allow searching by bulk number
        console.log("Searching products by bulk number is not allowed!");
        oThis.results = { rows: [], facets: [] };
        oThis.$emit("update:modelValue", 0);
        return;
      }
      oThis.isLoading = true;
      if (!fromWithin && !this.isFirstQuery) {
        this.selectedFacetOptions = [];
        SessionState.set("products", "facets", null);
      }
      this.isFirstQuery = false;
      var url = Utils.constructNewQueryUrl("products", filters.query, this.selectedFacetOptions);
      if (this.showGreenProducts) {
        url += "&greenProducts=1";
      }
      if (!this.removeCountryFilter) {
        url += `&countryFilter=${this.getCurrentCountry()}`;
      }
      if (this.settings.products.extraFacets) {
        url += `&extraFacets=${encodeURIComponent(this.settings.products.extraFacets)}`;
      }
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results);
        var mustReload = false;
        if (oThis.tags.length > 0) {
          mustReload = oThis.selectTagsInFacets();
        }
        oThis.$emit("update:modelValue", oThis.results.totalRows);
        Utils.applyVisualUpdates(".product-search");
        oThis.isLoading = false;
        if (!fromWithin) {//we only report to analytics search queries, not results refining
          Utils.reportResultsToAnalytics("Product Search", filters.query, oThis.results.totalRows);
        }
        if (mustReload) {
          oThis.search({ query: oThis.currentQuery, tags: "" }, true);
        }
      }).catch(function (err) {
        console.error("Error loading products: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.$emit("update:modelValue", oThis.results.totalRows);
        oThis.isLoading = false;
      });

    },
    onToggleGreenProducts() {
      this.showGreenProducts = !this.showGreenProducts;
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("products", "green_products", this.showGreenProducts ? "1" : "0");
    },
    onToggleRemoveCountryFilter() {
      this.removeCountryFilter = !this.removeCountryFilter;
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("products", "remove_country_filter", this.removeCountryFilters ? "1" : "0");
    },
    onShowMore() {
      var oThis = this;
      if (oThis.isLoading) return;
      console.log("Searching for more products with " + this.currentQuery)
      oThis.isLoading = true;
      var url = Utils.constructQueryUrl("products", this.currentQuery, oThis.results, oThis.selectedFacetOptions);
      if (this.showGreenProducts) {
        url += "&greenProducts=1";
      }
      if (!this.removeCountryFilter) {
        url += `&countryFilter=${this.getCurrentCountry()}`;
      }
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, true);
        Utils.applyVisualUpdates(".product-search");
        oThis.isLoading = false;
      }).catch(function (err) {
        console.error("Error loading products: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.isLoading = false;
      });
    },
    onApplyFilters(facetId, selectedOptions) {
      var updatedOptions = this.selectedFacetOptions.filter(option => !option.startsWith(facetId))
      updatedOptions.push(...selectedOptions);
      this.selectedFacetOptions = updatedOptions
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("products", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    onResetFilters(all, facetId) {
      if (all) {
        this.selectedFacetOptions = [];
      }
      else {
        this.selectedFacetOptions = this.selectedFacetOptions.filter(option => !option.startsWith(facetId));
      }
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("products", "facets", null);
    },
    selectTagsInFacets() {
      if (!this.tags || this.tags.length == 0) return;
      if (this.results.facets.length == 0) return;
      var oThis = this;
      var bMustReload = false;
      var tags = oThis.tags.split(',');
      this.results.facets.forEach(function (facet) {
        facet.options.forEach(function (opt) {
          if (tags.indexOf(opt.id) != -1) {
            oThis.selectedFacetOptions.push(facet.id + "=" + opt.id);
            var pos = oThis.collapsedFacets.indexOf(facet.name);
            if (pos != -1) oThis.collapsedFacets.splice(pos, 1);  //we expand the category automatically
            bMustReload = true;
          }
        });
      });
      return bMustReload;
    },
    getDocFinderUrl(product) {
      if (!product) return "";
      return `${Settings.docFinderUrl}?q=${encodeURIComponent(product.title)}`;
    },
    shouldShowSDSLink(product) {
      if (!Settings.docFinderUrl) return false;
      if (!Settings.restrictSDSLinkToBUs) return true;
      var show = false;
      product.tags.map(t => {
        if (Settings.restrictSDSLinkToBUs.indexOf(t) !== -1) show = true;
      });
      return show;
    },
    productSubtitle(product) {
      const matchCount = this.results.rows.reduce((count, row) => row.title === product.title ? count + 1 : count, 0);
      return matchCount === 1 ? product.subtitle : `${product.businessLine} - ${product.subtitle}`;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width: 100%;
  justify-content: center;
}

.product-search>div {
  display: flex;
  flex-direction: row;
}

.product-search .products {
  width: 100%;
}

.products .product-entry {
  display: flex;
  border-bottom: 2px solid #D9D9D9;
  padding: 32px 0;
}

.products .product-entry .product-image {
  width: 120px;
  height: 120px;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  min-width: 120px;
  margin-right: 16px;
}

.products .product-entry .product-details {
  margin-left: 10px;
  color: #323232;
  cursor: pointer;
}

.products .product-entry .product-details .product-title {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 500;
  margin-top: -4px;
}

.products .product-entry .product-details div.product-subtitle {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
}

.products .product-entry .product-details .product-description {
  font-family: "Gotham Narrow", Arial, Helvetica, sans-serif;
  font-size: 15px;
}

.product-search .green-products {
  margin-top: 20px;
}

.product-description .links {
  margin-top: 8px;
}

.product-description .links .blue-arrow {
  display: inline-block;
}

.product-description .links .more {
  margin-right: 48px;
}  

@media all and (max-width: 780px) {
  .product-search>div {
    flex-wrap: wrap-reverse;
  }


  .product-search .products {
    width: 100%;
  }

}</style>
